import { inject, ENVIRONMENT_INITIALIZER } from "@angular/core";
import type { Route } from "@angular/router";
import { VIEWER_PROVIDERS } from "./features/viewer/viewer-providers";
import { NowcastingProvider } from "./features/viewer/components/nowcasting/nowcasting-provider";
import { TemperatureProvider } from "./features/viewer/components/temperature/temperature-provider";
import { FireLayerProvider } from "./features/viewer/components/fire/fire-layer-provider";
import { authGuard, publicGuard } from "./features/auth/shared/auth.guard";

export const appRoutes: Route[] = [
  // ── Raíz: DecisionView (Centro de Decisión, nuevo diseño) ───
  {
    path: "",
    canActivate: [authGuard],
    // OptInPreloadStrategy descarga este chunk en idle mientras el usuario
    // aún ve /login: al autenticar, la navegación no espera a ArcGIS.
    data: { preload: true },
    providers: [
      ...VIEWER_PROVIDERS,
      // Disparo garantizado al nacer el inyector de la ruta:
      // build() → loadReport() sin depender del orden de componentes.
      {
        provide: ENVIRONMENT_INITIALIZER,
        multi: true,
        useValue: () => inject(NowcastingProvider),
      },
      // Capa de temperatura por unidad afectada (dpto → provincia según zoom).
      {
        provide: ENVIRONMENT_INITIALIZER,
        multi: true,
        useValue: () => inject(TemperatureProvider),
      },
      // Acota las capas de incendios al ámbito elegido. No tiene componente
      // propio: sin este disparo su build() no correría hasta que algo lo
      // inyectara, y el filtro nunca se aplicaría.
      {
        provide: ENVIRONMENT_INITIALIZER,
        multi: true,
        useValue: () => inject(FireLayerProvider),
      },
    ],
    loadComponent: () =>
      import("./features/viewer/views/decision-view").then((m) => m.DecisionView),
  },

  // ── /clasico: AlertView original (STD Dashboard) ────────────
  {
    path: "clasico",
    canActivate: [authGuard],
    providers: [...VIEWER_PROVIDERS],
    loadComponent: () =>
      import("./features/viewer/views/alert-view").then((m) => m.AlertView),
  },

  // ── /login: única ruta pública; autenticados son llevados a "/" ──
  {
    path: "login",
    canActivate: [publicGuard],
    loadComponent: () =>
      import("./features/auth/views/login-view/login-view").then((m) => m.LoginView),
  },
];
